import faixasSimplesNacional from '@/assets/json/faixasSimplesNacional.json'
import impostosTabela from '@/assets/json/impostosInssIrpf.json'

const calculator = {
  calculate(data) {
    const { type, activity, anexos, salary, healthPlan, food, transport, others } = data;

    this.allBenefits = healthPlan + food + transport + others;
    this.activity = activity;
    this.anexos = anexos;

    return this['calculate' + type](salary);
  },

  calculateclt(salary) {
    const resultsClt = this.calculators.clt(
      salary,
    );
    const currentLiquid = resultsClt.salaryLiquid;
    const salaryWithBenefits = salary + calculator.allBenefits;

    const calculatorResultsEmpresa = this.calculators.inverse.calculate(
      currentLiquid,
      salaryWithBenefits,
      this.calculators.empresa,
    )
    return {
      calculatorResultsClt: resultsClt,
      calculatorResultsEmpresa,
    };
  },

  calculateempresa(salary) {
    const resultsEmpresa = this.calculators.empresa(salary);
    const currentLiquid = resultsEmpresa.salaryLiquid;
    const salaryWithBenefits = salary + calculator.allBenefits;

    const calculatorResultsClt = this.calculators.inverse.calculate(
      currentLiquid,
      salaryWithBenefits,
      this.calculators.clt,
    )
    return {
      calculatorResultsClt,
      calculatorResultsEmpresa: resultsEmpresa,
    };
  },

  calculators: {
    clt(salary) {
      const FGTS = salary * 0.08;
      const INSS = calculator.taxes.INSS(salary);
      const vacation = calculator.taxes.ferias(salary);
      const salary13 = calculator.taxes.salary13(salary);
      const impostoRenda = calculator.taxes.IRPF(salary - INSS);
      const benefits = calculator.allBenefits;

      const contractorSalary13 = (salary / 12);
      const contractorVacantion = ((salary / 3) / 12);

      const contractingCost = (salary * 1.2) + benefits + contractorSalary13 + contractorVacantion + FGTS;

      const salaryLiquid = salary + benefits + salary13 + vacation + FGTS - INSS - impostoRenda;
      const salaryLiquidToGetToSalaryTotal = salary + benefits;

      return {
        salary,
        salary13,
        vacation,
        INSS,
        FGTS,
        impostoRenda,
        benefits,
        salaryLiquid,
        salaryLiquidToGetToSalaryTotal,
        contractingCost,
      };
    },

    empresa(salary) {
      const contador = 129;
      const contadorConvencional = 400;
      const anexos = calculator.anexos;
      const benefits = calculator.allBenefits;
      const contractingCost = salary;
      const salaryWithBenefits = salary + calculator.allBenefits;
      let prolabore = 1212;

      if(prolabore < impostosTabela.prolabore) {
        prolabore = impostosTabela.prolabore;
      }

      const imposto = calculator.taxes.impostoFaturamentoPj(salaryWithBenefits, anexos);

      const INSS = calculator.taxes.INSSPjAuto(prolabore);
      const impostoRenda = calculator.taxes.IRPF(prolabore - INSS);

      const salaryLiquid = salary + benefits - imposto - impostoRenda - INSS - contador;
      const salaryLiquidSemCtbz = salary + benefits - imposto - impostoRenda - INSS - contadorConvencional;
      const salaryLiquidToGetToSalaryTotal = salary + benefits;

      return {
        salary,
        imposto,
        contador,
        contadorConvencional,
        impostoRenda,
        INSS,
        benefits,
        salaryLiquid,
        salaryLiquidSemCtbz,
        salaryLiquidToGetToSalaryTotal,
        contractingCost,
      };
    },
    inverse: {
      calculate(
        liquidSalaryToReach,
        beginPresumeWithSalary,
        calculateFunction
      ) {
        let currentPresumedSalary = beginPresumeWithSalary,
          calculation = this.calculateStep(
            currentPresumedSalary,
            liquidSalaryToReach,
            calculateFunction
          );
        let precision = calculation.newPrecision;

        while (!calculation.isPresumedSalaryCorrect) {
          const sumPresumedSalary = 0 < calculation.difference;

          currentPresumedSalary = sumPresumedSalary
            ? currentPresumedSalary + precision
            : currentPresumedSalary - precision;

          calculation = this.calculateStep(
            currentPresumedSalary,
            liquidSalaryToReach,
            calculateFunction
          );
          if (calculation.isPresumedSalaryCorrect) {
            this.calculateStep(
              currentPresumedSalary,
              liquidSalaryToReach,
              calculateFunction
            );
          }
          precision = calculation.newPrecision;
        }

        return calculation.calculatorResults;
      },

      calculateStep(
        currentPresumedSalary,
        liquidSalaryToReach,
        calculateFunction
      ) {
        const calculatorResults = calculateFunction(currentPresumedSalary),
          difference = liquidSalaryToReach - calculatorResults.salaryLiquid,
          isPresumedSalaryCorrect = 0.001 > difference && -0.001 < difference;

        return {
          calculatorResults: calculatorResults,
          difference: difference,
          isPresumedSalaryCorrect: isPresumedSalaryCorrect,
          newPrecision: this.recalculatePrecision(difference)
        };
      },
      recalculatePrecision(difference) {
        const differenceAbsolute = Math.abs(difference);
        let precision = 20;

        const precisionSteps = [
          1000000,
          500000,
          100000,
          50000,
          10000,
          5000,
          1000,
          500,
          100,
          50,
          10,
          5,
          1,
          0.5,
          0.1,
          0.05,
          0.01,
          0.005,
          0.001
        ];

        for (const step of precisionSteps) {
          if (step < differenceAbsolute) {
            precision = step;
            break;
          }
        }

        return precision;
      }
    }
  },
  taxes: {
    INSS(salary) {
      const { percentages, limit, fixed } = impostosTabela.INSS;

      if(salary >= limit) {
        return fixed;
      }

      return percentages.reduce((init, atual) => {
        if(salary < atual.from) {
          return init;
        }
        else if(salary >= atual.to) {
          return init + (atual.to - atual.from) * atual.value;
        }
        return init + (salary - atual.from) * atual.value;
      }, 0);
    },

    INSSPjAuto(salary) {
      let INSS = salary * 0.11;
      const maxINSSValue = impostosTabela.tetoINSS;
      INSS = INSS > maxINSSValue ? maxINSSValue : INSS;

      return INSS;
    },

    IRPF(salary) {
      const percentages = impostosTabela.IRPF.percentages;
      let calculo = {};
      let value = 0;

      percentages.map( range => {
        if(salary > range.from) {
          calculo = range.value;
        }
      })
      value = (salary * calculo.aliquota) - calculo.deduzir;
      return value;
    },

    ferias(salary) {
      const salarioAdicional = salary + (salary / 3);
      const INSSAdicional = this.INSS(salarioAdicional);
      const IRAdicional = this.IRPF(salarioAdicional - INSSAdicional);

      const salarioBase = salary;
      const INSSBase = this.INSS(salarioBase);
      const IRBase = this.IRPF(salarioBase - INSSBase);

      const salarioDiff = salarioAdicional - salarioBase;
      const INSSDiff = INSSAdicional - INSSBase;
      const IRDiff = IRAdicional - IRBase;

      const totalFerias = salarioDiff - INSSDiff - IRDiff;

      return totalFerias / 12;
    },

    salary13(salary) {
      let totalSalary = salary;

      const INSS = this.INSS(totalSalary);
      totalSalary -= INSS;

      const IR = this.IRPF(totalSalary);
      totalSalary -= IR;

      return totalSalary / 12;
    },

    impostoFaturamentoPj(salary, anexos) {
      let impostoTotal = 0;
      const faturamentoAnual = salary * 12;

      function calculateTaxByAnexo(anexo) {
        faixasSimplesNacional[`anexo${anexo}`].map( range => calculateTax(range));
      }

      calculateTaxByAnexo(anexos)

      function calculateTax(range) {
        if(faturamentoAnual >= range.from) {
          impostoTotal = ((faturamentoAnual * Math.abs(range.value)) - range.deduct) / 12;
        }
      }

      return impostoTotal;
    }
  }
};

export default calculator;
